var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFassadeDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8f8f8f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M62.707,31.293l-30-30a1,1,0,0,0-1.414,0l-30,30A1,1,0,0,0,2,33H7V57H6a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H58a1,1,0,0,0,1-1V58a1,1,0,0,0-1-1H57V33h5a1,1,0,0,0,.707-1.707ZM57,61H7V59H57ZM27,57H15V39H27Zm2,0V38a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1V57H9V32.414l23-23,23,23V57ZM56.414,31,32.707,7.293a1,1,0,0,0-1.414,0L7.586,31H4.414L32,3.414,59.586,31Z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m39 26a7 7 0 1 0-7 7 7.008 7.008 0 0 0 7-7zm-12 0a5 5 0 1 1 5 5 5.006 5.006 0 0 1-5-5z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m52 37h-20a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1zm-1 7h-8v-5h8zm-10-5v5h-8v-5zm-8 7h8v5h-8zm10 5v-5h8v5z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "",
    x: 17,
    y: 45,
    width: 2,
    height: 4,
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFassadeDisabled);
export default __webpack_public_path__ + "static/media/fassade_disabled.fdd8296092b2e45cc274cb8f4e134a19.svg";
export { ForwardRef as ReactComponent };